import React from "react";
import { MapPin } from "lucide-react";
import toastError from "../../errors/toastError";

const LocationPreview = ({ image, link, description }) => {
  const handleLocation = () => {
    try {
      window.open(link);
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <div className="min-w-[250px] rounded-lg overflow-hidden border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800">
      <div className="flex items-start gap-3 p-3">
        {image && (
          <img
            src={image}
            onClick={handleLocation}
            className="w-24 h-20 object-cover rounded-md cursor-pointer flex-shrink-0"
            alt="location"
          />
        )}
        {description && (
          <p
            className="text-sm text-slate-700 dark:text-slate-300 mt-1 leading-snug"
            dangerouslySetInnerHTML={{ __html: description.replace("\\n", "<br />") }}
          />
        )}
      </div>
      <div className="border-t border-slate-200 dark:border-slate-700">
        <button
          onClick={handleLocation}
          disabled={!link}
          className="w-full flex items-center justify-center gap-1.5 py-2 text-sm font-semibold text-indigo-600 dark:text-indigo-400 hover:bg-slate-50 dark:hover:bg-slate-700/50 disabled:opacity-40 transition-colors"
        >
          <MapPin className="w-4 h-4" />
          Visualizar
        </button>
      </div>
    </div>
  );
};

export default LocationPreview;
